import { ContactInfo } from '../common/ContactInfo';

export function StateCoordinator_MyAccount() {
  return <ContactInfo />;
}
